import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { ActionsRender } from './components/actions-render';
import { ActionsRenderProps, WithAdditionalType } from './components/actions-render/types';
import { BaseTable, BaseTableProps } from './components/base-table';
import { ACTION_KEY } from './constants';
import { ColumnDefinitionInterface } from './types/column-interface';
import { InstanceForPaginationType } from './types/instance-interface';
import { getRowId } from './utils';
export type TableProps<T, K> = BaseTableProps<T> & Partial<Omit<ActionsRenderProps<T, K>, 'instance'>>;
export function Table(t0) {
  const $ = _c(24);
  let actions;
  let actionsOrder;
  let caption;
  let columns;
  let nestedId;
  let paginationIdField;
  let restProps;
  let testAttributePostfix;
  if ($[0] !== t0) {
    ({
      testAttributePostfix,
      nestedId,
      paginationIdField,
      actions,
      caption,
      columns,
      actionsOrder,
      ...restProps
    } = t0);
    $[0] = t0;
    $[1] = actions;
    $[2] = actionsOrder;
    $[3] = caption;
    $[4] = columns;
    $[5] = nestedId;
    $[6] = paginationIdField;
    $[7] = restProps;
    $[8] = testAttributePostfix;
  } else {
    actions = $[1];
    actionsOrder = $[2];
    caption = $[3];
    columns = $[4];
    nestedId = $[5];
    paginationIdField = $[6];
    restProps = $[7];
    testAttributePostfix = $[8];
  }
  let t1;
  if ($[9] !== actions || $[10] !== actionsOrder || $[11] !== caption || $[12] !== columns || $[13] !== nestedId || $[14] !== paginationIdField || $[15] !== restProps || $[16] !== testAttributePostfix) {
    t1 = actions && Object.keys(actions).length > 0 ? [...columns, {
      key: ACTION_KEY as keyof T,
      header: "",
      onRender: instance => <ActionsRender caption={caption} actions={actions} instance={instance as WithAdditionalType<T, K>} rowId={getRowId({
        row: instance,
        nestedId,
        paginationIdField,
        rowIdParser: restProps.rowIdParser
      })} testAttributePostfix={testAttributePostfix} actionsOrder={actionsOrder} />
    }] : columns;
    $[9] = actions;
    $[10] = actionsOrder;
    $[11] = caption;
    $[12] = columns;
    $[13] = nestedId;
    $[14] = paginationIdField;
    $[15] = restProps;
    $[16] = testAttributePostfix;
    $[17] = t1;
  } else {
    t1 = $[17];
  }
  const columnsWithActions = t1;
  let t2;
  if ($[18] !== columnsWithActions || $[19] !== nestedId || $[20] !== paginationIdField || $[21] !== restProps || $[22] !== testAttributePostfix) {
    t2 = <BaseTable nestedId={nestedId} paginationIdField={paginationIdField} columns={columnsWithActions} testAttributePostfix={testAttributePostfix} {...restProps} />;
    $[18] = columnsWithActions;
    $[19] = nestedId;
    $[20] = paginationIdField;
    $[21] = restProps;
    $[22] = testAttributePostfix;
    $[23] = t2;
  } else {
    t2 = $[23];
  }
  return t2;
}